const en = {
  // PROFILE Section
  PROFILE_TITLE: 'Profile',
  PROFILE_TEXT: 'As an engineer with a degree, I have a passion for web technologies. I have 4 years\' experience in a start-up and in a well established firm where I was able to progress and grow rapidly. I\'m currently looking for a new job as a web developer or project manager.',
  PROFILE_TEXT_2: 'I am rigorous, polyvalent and determined, and I always like to take on new challenges. I\'m very flexible and I\'m always ready to listen to the people around me.',
  PROFILE_TEXT_3: 'I have experience in project management, finding real satisfaction in working on exciting initiatives and building effective bridges between the business requirements and the technical aspects of IT development.',

  // FORMATIONS Section
  FORMATION_TITLE: 'Formations',
  FORMATION_OPTIONS_TITLE: 'Courses attended :',
  FORMATION_PROJECTS_TITLE: 'Projects and associations :',

  // EXPERIENCES Section
  EXPERIENCE_TITLE: 'Professional experience',
  EXPERIENCE_TECHNOS: 'USED TECHS',
  EXPERIENCE_MISSIONS: 'MAIN MISSIONS',

  // SKILLS Section
  SKILL_TITLE: 'Skills',
  SKILL_ANALYSIS: 'FUNCTIONAL ANALYSIS',

  // LANGUAGES Section
  LANGUAGE_TITLE: 'Languages',
  LANGUAGE_FRENCH: 'French',
  LANGUAGE_ENGLISH: 'English',
  LANGUAGE_GERMAN: 'German',
  LANGUAGE_TOEIC_TEXT: 'TOEIC : ',
  LANGUAGE_TOEIC_SCORE: '930',

  // USER Section
  USER_FULLNAME: 'Nicolas PIERRE',
  USER_PROFESSION: 'Fullstack developper',
  USER_ADDRESS: '9 rue d\'Australie, 91300 Massy, France',
  USER_PHONE: '+33 6 51 89 72 48',
  USER_EMAIL: 'npierre9@yahoo.fr',
  USER_BIRTHDATE: 'Birth date: 9th August 1998',
  USER_BIRTHPLACE: 'Birth Location: Massy, France',
  USER_DRIVING_LICENSE: 'French driving license',
  USER_BOAT_LICENSE: 'French boat license',

  // INTERESTS section
  INTEREST_TITLE: 'Hobbys',
  INTEREST_1: 'Scuba diving',
  INTEREST_1_TEXT: 'I train weekly in the pool, I\'ve passed my N2 level and I take part in diving competitions with my club.',
  INTEREST_2: 'Fencing',
  INTEREST_2_TEXT: 'I\'ve been a weekly épée fencer at a club for around 10 years and I have won a few medals in competitions. I aim at winning even more in the years to come.',
  INTEREST_3: 'Chess',
  INTEREST_3_TEXT: 'Regular player on the Chess.com website, I have an intermediate level ({blitzElo} ELO in blitz, {rapidElo} ELO in rapid). I recently joined a chess club with the ambition of becoming stronger.',
  INTEREST_4: 'Photography',
  INTEREST_4_TEXT: 'President of the Ecole des Mines photography and video club for 2019-2020.',
  INTEREST_5: 'Video games',
  INTEREST_5_TEXT: 'Strong attachment to the world of video games, regular player of competitive games (Rocket League, Valorant, Counter-Strike), cooperative games (Minecraft, Terraria) or solo games.',

  // EXTERNAL_LINKS Section
  EXTERNAL_LINK_TITLE: 'Social links',
};

export default en;
